import(/* webpackMode: "eager" */ "/app/apps/seller/app/(public)/privacy/page.tsx");
